<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <div class="section-title-02">
          <h3>My Portfolio</h3>
        </div>
      </div>
      <div class="col-lg-4 text-lg-right">
        <a class="btn btn-primary btn-md mb-4 mb-lg-0" [routerLink]="" (click)="onPreviewResume(resumeId)">Preview My
          Portfolio</a>
      </div>
      <div class="col-12">
        <form [formGroup]="form">
          <div class="user-dashboard-info-box">
            <div class="form-group col-md-12 p-0">
              <label>About Me</label>
              <textarea class="form-control" rows="4" formControlName="aboutMe"></textarea>
            </div>
          </div>
          <!--=================================
          Professional Skill -->
          <div class="user-dashboard-info-box">
            <div class="dashboard-resume-title d-flex align-items-center">
              <div class="section-title-02 mb-sm-0">
                <h4 class="mb-0">Professional Skills</h4>
              </div>
              <a class="btn btn-md ml-sm-auto btn-primary" [routerLink]="" (click)="toggleSkills()">Add Skills</a>
            </div>
            <app-skills-form [collapse_skills]="collapse_skills"></app-skills-form>
          </div>
          <!--=================================
          Professional Skill -->
          <!--=================================
          Portfoio -->
          <div class="user-dashboard-info-box">
            <div class="dashboard-resume-title d-flex align-items-center">
              <div class="section-title-02 mb-sm-0">
                <h4 class="mb-0">Portfolio</h4>
              </div>
              <a class="btn btn-md ml-sm-auto btn-primary" [routerLink]="" (click)="togglePortfoio()">Add Portfolio</a>
            </div>
            <app-portfolio-attachment [resumeId]="resumeId"></app-portfolio-attachment>
            <app-attachments-preview [componentType]="componentTypes.PortfolioComponent"
            ></app-attachments-preview>
          </div>
          <!--=================================
          Portfoio -->
          <!--=================================
          Work & Experience -->
          <div class="user-dashboard-info-box">
            <div class="dashboard-resume-title d-flex align-items-center">
              <div class="section-title-02 mb-sm-0">
                <h4 class="mb-0">Work & Experience</h4>
              </div>
              <a class="btn btn-md ml-sm-auto btn-primary" data-toggle="collapse" [routerLink]="" role="button"
                (click)="toggleExperience()" aria-expanded="false" aria-controls="dateposted">Add Experience</a>
            </div>
            <app-experience-form [collapse_experience]="collapse_experience"></app-experience-form>
            <div class="jobber-candidate-timeline mt-4">
              <div *ngIf="showBriefCase == true" class="jobber-timeline-icon">
                <i class="fas fa-briefcase"></i>
              </div>
              <div *ngFor="let experience of dashboardState.experiences | async; let i = index">
                <app-experience-preview *ngIf="!experience.hidden" [experience]="experience" [index]="i"
                  [readonly]="false"></app-experience-preview>
              </div>
            </div>
          </div>
          <!--=================================
          Education -->
          <div class="user-dashboard-info-box">
            <div class="dashboard-resume-title d-flex align-items-center">
              <div class="section-title-02 mb-sm-0">
                <h4 class="mb-0">Education</h4>
              </div>
              <a class="btn btn-md ml-sm-auto btn-primary" data-toggle="collapse" [routerLink]="" role="button"
                (click)="toggleEducation()" [attr.aria-expanded]="[collapse_education]" aria-controls="dateposted">Add
                Education</a>
            </div>
            <app-education-form [collapse_education]="collapse_education"></app-education-form>
            <div class="jobber-candidate-timeline mt-4">
              <div *ngIf="showEducationCap == true" class="jobber-timeline-icon">
                <i class="fas fa-graduation-cap"></i>
              </div>
              <app-education-preview *ngFor="let education of dashboardState.educations | async; let i = index"
                [education]="education" [index]="i" [readonly]="false"></app-education-preview>
            </div>
          </div>
          <!--=================================
          Education -->
          <!--=================================
          Certifications -->
          <div class="user-dashboard-info-box">
            <div class="dashboard-resume-title d-flex align-items-center">
              <div class="section-title-02 mb-sm-0">
                <h4 class="mb-0">Certifications</h4>
              </div>
              <a class="btn btn-md ml-sm-auto btn-primary" [routerLink]="" (click)="toggleCertifications()">Add
                Certifications</a>
            </div>
            <app-certificate-form [shouldCollapse]="collapse_certifications"></app-certificate-form>
          </div>
          <!--=================================
          Certifications -->
        </form>
      </div>
    </div>
  </div>
  <div class="container sticky">
    <div class="row">
      <div class="col-12">
        <div class="bottom-bar">
          <a class="btn btn-md btn-primary save-btn" [routerLink]="" (click)="save()">Save All</a>
        </div>
      </div>
    </div>
  </div>
</section>
